export const support = {
  seo: {
    title: 'Contact & Support | Bistroo',
    description: 'Neem contact op met het Bistroo-supportteam via telefoon, WhatsApp of e-mail. We helpen je snel verder.',
  },
  hero: {
    heading: {
      1: 'Onze',
      2: 'klantenservice',
      3: 'staat graag voor je klaar',
    },
    description: {
      1: 'Welkom bij onze klantenservice',
      2: 'Om je goed van dienst te kunnen zijn, vragen we je om hieronder een keuze te maken uit de beschikbare opties. Zo zorgen we ervoor dat je direct bij de juiste informatie of contactmogelijkheid terechtkomt.',
    },
  },
  cards: {
    helpcenter: {
      description: 'Alle informatie die je nodig hebt',
      title: 'Helpcenter & FAQ',
      text: 'Bezoek ons helpcenter voor advies en antwoord op al je vragen. Of lees onze FAQ pagina met de meest gestelde vragen.',
      actions: {
        helpcenter: 'Bezoek het helpcenter',
        faq: 'Meest gestelde vragen',
      },
    },
    demo: {
      description: 'Support team',
      title: 'Een demo',
      text: 'Een demo met ons team?',
      action: {
        title: 'Een demo aanvragen',
        button: 'Aanvragen',
      },
    },
    address: {
      description: 'Bistroo',
      title: 'Ons adres',
      text: 'Je kunt ons vinden op onderstaand adres',
      address: {
        mail: 'Post adres:',
        visit: 'Bezoek adres (op afspraak)',
      },
    },
    contact: {
      description: 'Ons bereiken',
      title: 'Contact',
      text: 'Wil je direct contact met ons opnemen? Dat kan!',
    },
    partners: {
      description: 'Partner worden',
      title: 'Partners',
      text: 'Laat je business groeien en wordt partner van Bistroo!',
      action: {
        title: 'Wordt partner',
        button: 'Lees verder',
      },
    },
  },
}
